import React from 'react'

function ChubmapIsland() {
  return (
    <>
    <main>
    <div className="chubs-list container-fluid">
    <div className="row mz-spacing" data-aos="fade-up" data-aos-duration="1000">
        <div className='col-sm-8 col-md-6 offset-md-3 offset-sm-2'>
            <img src='assets/images/Island/1.png' className="img-fluid mx-auto d-block" alt="Chub Run" width={632} height={475}/>
        </div>
    </div>
    <div className="row mz-spacing" data-aos="fade-up" data-aos-duration="1000">
        <div className='col-sm-6 col-md-4 offset-md-1'>
            <img src='assets/images/Island/2.png' className="img-fluid mx-auto d-block" alt="Chub Code" width={530} height={530}/>
        </div>
        <div className='col-sm-6 col-md-4 offset-md-2'>
            <img src='assets/images/Island/3.png' className="img-fluid mx-auto d-block" alt="Chub Code" width={535} height={535}/>
        </div>
    </div>
    <div className="row mz-spacing" data-aos="fade-up" data-aos-duration="1000">
        <div className='col-sm-6 offset-sm-3'>
            <img src='assets/images/Island/4.png' className="img-fluid mx-auto d-block" alt="Chub Run" width={680} height={510}/>
        </div>
    </div>
    <div className="row" data-aos="fade-up" data-aos-duration="1000">
        <div className='col-sm-6 col-md-4 offset-md-1'>
            <img src='assets/images/Island/5.png' className="img-fluid mx-auto d-block" alt="Chub Code" width={545} height={705}/>
        </div>
        <div className='col-sm-6 col-md-4 offset-md-2 mz-spacing'>
            <img src='assets/images/Island/6.png' className="img-fluid mx-auto d-block" alt="Chub Code" width={544} height={704}/>
        </div>
    </div>
    <div className="row mz-spacing" data-aos="fade-up" data-aos-duration="1000">
        <div className='col-sm-8 col-md-6 offset-md-3 offset-sm-2'>
            <img src='assets/images/Island/7.png' className="img-fluid mx-auto d-block" alt="Chub Run" width={658} height={658}/>
        </div>
    </div>
    <div className="row mz-spacing" data-aos="fade-up" data-aos-duration="1000">
        <div className='col-sm-6 col-md-4 offset-md-1'>
            <img src='assets/images/Island/8.png' className="img-fluid mx-auto d-block" alt="Chub Code" width={537} height={415}/>
        </div>
        <div className='col-sm-6 col-md-4 offset-md-2'>
            <img src='assets/images/Island/9.png' className="img-fluid mx-auto d-block" alt="Chub Code" width={557} height={557}/>
        </div>
    </div>
    <div className="row mz-spacing" data-aos="fade-up" data-aos-duration="1000">
        <div className='col-sm-8 col-md-6 offset-md-3 offset-sm-2'>
            <img src='assets/images/Island/10.png' className="img-fluid mx-auto d-block" alt="Chub Run" width={674} height={873}/>
        </div>
    </div>
    <div className="row mz-spacing" data-aos="fade-up" data-aos-duration="1000">
        <div className='col-sm-10 col-md-8 offset-md-2 offset-sm-1'>
            <img src='assets/images/Island/11.png' className="img-fluid mx-auto d-block" alt="Chub Run" width={1272} height={533}/>
        </div>
    </div>
    </div>
    </main>
    </>
  )
}

export default ChubmapIsland;